import { useCallback, useEffect, useState } from "react";
import MaterialTable from "material-table";
import DataService from "../../../../../Service";
import { makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import StatusDot from "../../../../../Components/status_dot";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { useHistory } from "react-router-dom";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import SearchByCategory from "../../../../../Components/category_based_search";
import ViewSummary from "../../../Organization/ManageInfo/view_summary";
import ColumnsSelector from "../../../Organization/ManageInfo/ColumnsSelector";
import ExportSelector from "../../../Organization/ManageInfo/ExportSelector";
import MIFeedbackModal from "../../../Organization/ManageInfo/MIFeedbackModal";
import {
  Box,
  Modal,
  Fade,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import AssigmentFilterModal from "../../../Organization/ManageInfo/AssigmentFilterModal";
import moment from "moment";

import FilterListIcon from "@material-ui/icons/FilterList";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
import useDebounce from "../../../../../Components/debounce";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "5%",
    PaddingTop: "2%",
  },
  actionButtons: {
    marginTop: "-3%",
    textAlign: "center",
    paddingLeft: "25px",
  },
  tableWrapper: {
    width: "95%",
    paddingLeft: "2%",
    margin: "2% 3%",
  },

  bodyContainer: {
    maxWidth: "92%",
    flexGrow: 1,
    margin: "0 auto",
    marginTop: "20px",
  },
  bodyContainer1: {
    maxWidth: "90%",
    margin: "0 auto",
    marginTop: "20px",
  },
  row: {
    "& button": {
      display: "none",
    },
    "&:hover": {
      "& button": {
        display: "inline-block",
      },
    },
  },
  searchCategory: {
    marginLeft: "25rem",
    marginRight: "1rem",
    width: "504px",
    "& div": {},
  },
  textPrimary: {
    color: theme.palette.primary.main,
  },

  textSecondary: {
    color: theme.palette.secondary.main,
  },
  miTable: {
    "& .MuiPaper-root": {
      boxShadow: "1px 5px 5px #888888",
    },
    "& .MuiToolbar-root": {
      "& .material-icons": {
        color: theme.palette.secondary.main,
      },
    },
  },
  datepickerPopover: {
    textAlign: "right",
    fontSize: "16px",
    marginBottom: "33px",
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    "& button": {
      backgroundColor: "#ffffff",
      border: "1px solid #d7dae2",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    },
  },
  MuiTable: {
    "& tbody td": {
      fontSize: theme.typography.h2.fontSize,
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 20,
  },
  paper: {
    backgroundColor: "#fff",
    boxShadow: theme.shadows[5],
    padding: 20,
    textAlign: "left",
  },
  modalInner: {
    width: 600,
    borderRadius: 10,
    maxHeight: 500,
    overflow: "auto",
  },
  headerStyle: {
    color: theme.palette.primary.main,
    textAlign: "left",
  },
}));

const rawData = [];
const ITEM_HEIGHT = 48;
const options1 = ["View summary", "View details"];
function Assignment(props) {
  const classes = useStyles();
  const globaluserData = useSelector((state) => state.commonReducer);

  const { organisationId } = props;
  console.log(props, "props params");
  const dispatch = useDispatch();
  const [currentSelection, setCurrentSelection] = useState({});
  const [hiddenCol, setHiddenCol] = useState(false);
  const [action, setAction] = useState("");
  const [modules, setModules] = useState(null);
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 700);
  const [totalCount, setTotalCount] = useState(100);
  const [totalAssignmentCount, setTotalAssignmentCount] = useState(-1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [viewAction, setViewAction] = useState(null);
  const [dropDownOption, setDropDownOption] = useState(null);
  const [anchorPopover, setAnchorPopover] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchCategory, setSearchCategory] = useState({});
  const [assignmentData, setAssignmentData] = useState([]);
  const [data, setData] = useState(rawData);
  const [filterModal, setFilterModal] = useState(false);
  const [organizationList, setOrganizationList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [serviceTypeList, setServiceTypeList] = useState([
    { id: 1, name: "internal", value: "Internal" },
    { id: 2, name: "external", value: "External" },
  ]);
  const [dropDownValue, setDropDownValue] = useState(null);
  const [drawerFilterValue, setDrawerFilterValue] = useState(null);
  const [organizationLoader, setOrganizationLoader] = useState(false);
  let role = globaluserData?.role;

  const [filterDataState, setFilterDataState] = useState([
    {
      startDate: role === "admin" ? null : moment().subtract(1, "year"),
      endDate: role === "admin" ? null : moment(),
      key: "selection",
      color: "#99adad",
    },
  ]);
  const [anchorElPicker, setAnchorElPicker] = useState(null);
  const [filterStatisticsValue, setFilterStatisticsValue] = useState("");
  const [isFeedback, setIsFeedback] = useState(false);
  const [, setForceUpdate] = useState(0);
  const open = Boolean(anchorEl);

  const forceUpdate = () => setForceUpdate((old) => old + 1);
  const i = 2;
  let history = useHistory();
  const filteredItems = options1
    .slice(0, i)
    .concat(options1.slice(i + 1, options1.length));

  const dropdownOptions = [
    { label: "Coachee", value: "coachee" },
    { label: "Program type", value: "programme_type" },
    { label: "Location", value: "location" },
  ];
  useEffect(() => {
    fetchSpecificAssignments();
  }, [
    searchCategory,
    page,
    pageSize,
    debouncedSearchText,
    drawerFilterValue,
    filterDataState,
    organisationId,
  ]);

  const [mainFilter, setMainFilter] = useState("");

  const fetchSpecificAssignments = (value) => {
    setMainFilter(value?.main_filter);
    setOrganizationLoader(true);
    let params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
    };
    if (organisationId) {
      params["organisation_id"] = organisationId;
    }

    if (searchCategory?.value) {
      params["programme_type"] = searchCategory?.value;
    }
    if (searchText) {
      params["coachee_name"] = searchText;
      params["search_keyword"] = searchText;
    }

    DataService.getDirectData("/assignments/list_org_assignments", params)
      .then((res) => {
        // DataService.getData(params, 'list_all_assignments').then((res) => {
        if (res?.success) {
          setTotalAssignmentCount(res?.assignments_count);
          setTotalCount(res?.total_count);
          setAssignmentData(res?.assignments);
          setOrganizationLoader(false);
        }
      })
      .catch(() => {
        setOrganizationLoader(false);
      });
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setCurrentSelection({});
    console.log("first");
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const InitialColumns = [
    {
      title: "Coachee name",
      headerStyle: { paddingLeft: "32px" },

      cellStyle: {
        width: "16%",
      },
      field: "coachee_name",
      render: (rowData) => {
        return (
          <div
            className="center"
            style={{
              position: "relative",
              paddingLeft: "16px",
              textAlign: "start",
            }}
          >
            {/* {rowData?.attention_status != "" && ( */}
            <IconButton
              onClick={(event) => {
                if (rowData.alert_message) {
                  setCurrentSelection(rowData);
                  setAnchorPopover(event.currentTarget);
                  setViewAction("view_more");
                }
              }}
              color="secondary"
              style={{ padding: 0, paddingRight: "6px" }}
            >
              <StatusDot
                variant={
                  rowData?.attention_status == "Green" ||
                  !rowData?.attention_status
                    ? "positive"
                    : rowData?.attention_status == "Red"
                    ? "negative"
                    : "warning"
                }
              />
            </IconButton>

            <Typography
              // color="primary"
              style={{
                textTransform: "none",
                // cursor: "pointer",
                fontSize: "16px",
                fontFamily: "open sans",
              }}
            >
              {rowData?.coachee_name || ""}
            </Typography>
          </div>
        );
      },
      customSort: (a, b) =>
        a.coachee_name !== null &&
        b.coachee_name !== null &&
        a.coachee_name.localeCompare(b.coachee_name),
    },
    {
      title: "Coach name",
      field: "coach_name",
      customSort: (a, b) => a.coach_name.localeCompare(b.coach_name),
      emptyValue: "-",
      cellStyle: {
        width: "16%",
      },
      render: (rowData) => {
        return (
          <Typography style={{ fontSize: "16px" }}>
            {rowData?.coach_name || ""}
          </Typography>
        );
      },
    },
    {
      title: "Follow up date",
      field: "follow_up_date",
      sorting: false,
      emptyValue: "-",
      hidden: role === "employee",
    },
    {
      title: "Overall status",
      field: "status",
      emptyValue: "-",
      sorting: true,
    },
    {
      title: "Final CA received",
      field: "final_CA_received",
      emptyValue: "-",
      sorting: false,
      hidden: true,
    },
    {
      title: "Client name",
      field: "organisation_name",
      customSort: (a, b) =>
        a.organisation_name.localeCompare(b.organisation_name),
      // hiddenByColumnsButton: true,
      // removable: true,
      hidden: role === "employee",
    },
    {
      title: "Program type",
      field: "programme_type",
      customSort: (a, b) => a.programme_type.localeCompare(b.programme_type),
      hiddenByColumnsButton: true,
      removable: true,
    },
    {
      title: "Total program cost",
      field: "total_programme_cost",
      sorting: false,
      render: (rowData) => {
        const [currency, amount] = rowData?.total_programme_cost?.split(" ");
        return (
          <Box
            width={"120px"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography style={{ textAlign: "left" }}>{currency}</Typography>
            <Typography style={{ textAlign: "right" }}>{amount}</Typography>
          </Box>
        );
      },
    },
    {
      title: "Account manager",
      field: "account_manager",
      hidden: true,
      sorting: false,
    },
    {
      title: "Number of hours",
      field: "number_of_hours",
      hidden: false,
      sorting: false,
    },
    {
      title: "Number of sessions",
      field: "number_of_sessions",
      hidden: true,
      sorting: false,
    },
    {
      title: "PA/Assistant (Name)",
      field: "pa_name",
      hidden: true,
      sorting: false,
    },
    {
      title: "PA/Assistant (contacts) ",
      field: "pa_contact_details",
      hidden: true,
      sorting: false,
    },
    {
      title: "LOB Leader",
      field: "lob_leader_name",
      hidden: true,
      sorting: false,
    },
    {
      title: "Account director",
      field: "account_director",
      hidden: true,
      sorting: false,
    },
    {
      title: "Name of HRBP",
      field: "HRBP_name",
      hidden: true,
      sorting: false,
    },
    {
      title: "Line Manager",
      field: "line_manager",
      hidden: true,
      sorting: false,
    },
    {
      title: "Evaluation form",
      field: "evaluation_form",
      hidden: true,
      sorting: false,
    },
    {
      title: "Delivery duration",
      field: "delivery_duration",
      hidden: true,
      sorting: false,
    },
    {
      title: "Client sponsor",
      field: "client_sponsor",
      hidden: true,
      sorting: false,
    },
    {
      title: "Date of next session",
      field: "date_of_next_session",
      hidden: true,
      sorting: false,
    },
    {
      title: "Date assignment received",
      field: "date_received",
      hidden: true,
      sorting: false,
    },
    {
      title: "Location",
      field: "location",
      // hidden: true,
      customSort: (a, b) => a.location.localeCompare(b.location),
    },
    {
      title: "Unit",
      field: "unit",
      hidden: true,
      sorting: false,
    },
    {
      title: "Email",
      field: "email",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "Title",
      field: "title",
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "First session date",
      field: "first_session_date",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "Last session date",
      field: "last_session_date",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "CRF received date",
      field: "crf_date_received",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "Date of briefing call",
      field: "briefing_call",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    // {
    //   title: "Agency",
    //   field: "agency",
    //   emptyValue: "-",
    //   hidden: true,
    //   sorting: false,
    // },
    // {
    //   title: "Bank ID ",
    //   field: "bank_id",
    //   emptyValue: "-",
    //   hidden: true,
    //   sorting: false,
    // },
    {
      title: "Cost centre",
      field: "cost_centre",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "Estimated completion date",
      field: "estimated_completion_date",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "Length of program",
      field: "length_of_programme",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "First name",
      field: "coachee_first_name",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "Last name",
      field: "coachee_last_name",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "Band/Level/Grade",
      field: "level_structure",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "Coaches proposed",
      field: "coaches_proposed",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    {
      title: "Coach Selected",
      field: "coach_selected",
      sorting: false,
    },
    {
      title:
        "Department/Office/ Division/ Business/Function/Global Business/ Unit/Team/Parent Division/Sub Division/Op Co/Business Area",
      field: "business_area",
      emptyValue: "-",
      sorting: false,
    },
    {
      title: "Virtual/ Face to Face/Hybrid",
      field: "virtual_or_face",
      emptyValue: "-",
      sorting: false,
    },
    {
      title: "Service type",
      field: "service_type",
      emptyValue: "-",
      sorting: false,
    },
    { title: "Service", field: "service", emptyValue: "-", hidden: true },
    {
      title: "Shortlist feedback",
      field: "shortlist_feedback",
      sorting: false,
      // emptyValue: '-',
      hidden: true,
      render: (rowData) => (
        <div id={`div-${rowData.id}`}>
          <IconButton
            aria-label="more"
            aria-controls={`long-menu-${rowData.id}`}
            aria-haspopup="true"
            onClick={(e) => {
              setCurrentSelection({
                assignment_id: rowData.id,
                session_scenario_id: 1,
                title: "Shortlist feedback",
              });
              setIsFeedback(true);
            }}
          >
            <VisibilityIcon />
          </IconButton>
        </div>
      ),
    },
    {
      title: "Chemistry/Rapport meeting dates",
      field: "chemistry_meeting_details",
      emptyValue: "-",
      hidden: true,
      sorting: false,
    },
    // {
    //   title: "Chemistry/ Rapport request Feedback",
    //   field: "chemistry_meeting_details",
    //   emptyValue: "-",
    //   hidden: true,
    //   sorting: false,
    // },

    {
      title: "Chemistry/Rapport client feedback",
      field: "chemistry_meeting_details_client",
      sorting: false,
      hidden: true,
      // emptyValue: '-',
      // hidden: true,
      render: (rowData) => (
        <div id={`div-${rowData.id}`}>
          <IconButton
            aria-label="more"
            aria-controls={`long-menu-${rowData.id}`}
            aria-haspopup="true"
            onClick={(e) => {
              setCurrentSelection({
                assignment_id: rowData.id,
                session_scenario_id: 2,
                title: "Chemistry/Rapport client feedback",
              });
              setIsFeedback(true);
            }}
          >
            <VisibilityIcon />
          </IconButton>
        </div>
      ),
    },
    {
      title: "Hogan certified",
      field: "hogan_certified",
      emptyValue: "-",
      sorting: false,
      hidden: true,
    },
    // {
    //   title: "Coordinator notes ",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Coordinator follow up date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Account Coordinator",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Fiscal Year",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Date of request",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Date of acknowledgement",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Coaching Initiation form sent date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Coaching Initiation received date ",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Coaching Initiation acknowledgement date ",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Coachee Request Form acknowledgement date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },  {
    //   title: "Pre Questionnaire Form sent date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Pre Questionnaire Form received date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Pre Questionnaire Form acknowledgement date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Programme name",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Virtual/ Face to Face/Hybrid",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },  {
    //   title: "Estimated Completion Date ",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Date of 360 Approval email to client",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    //   {
    //   title: "Date of 360 Approval email from client",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "360 Requested Y/N",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Hogan Requested Y/N",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    //   {
    //   title: "Client 360 to be used Y/N",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Pre Questionnaire to be used Y/N",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Region",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Department/Office/ Division/ Business/Function/Global Business/ Unit/Team/Parent Division/Sub Division/Op Co/Business Area",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Coaches Contacted date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Short List Sent date ",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Coachee availability date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Coachee availability acknowledgement email date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Coachee availability received date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Short List Feedback",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Coach Selected",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Confirmation emails sent dates for all stakeholders",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Request Evaluation Acuity service",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Client 360 Completed Y/N",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },

    //   {
    //   title: "Verbal 360 Stakeholder Interviews information",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Verbal 360 Stakeholder Interviews Completed Y/N",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },

    // {
    //   title: "Verbal 360 Stakeholder Interview names and dates of interviews",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Verbal 360 Stakeholder Interviews No Shows Text box",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Hogan initiated with APS date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Hogan Status completed Y/N",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Hogan Assessment Debrief Y/N ",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Hogan Assessment Debrief date",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "APS debrief with the Coach",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Psychometrics Used (if applicable)",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Psychometrics cost (if applicable)",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },

    //  {
    //   title: "Psychometrics Used Approval email",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    //  {
    //   title: "Psychometrics Used Approval",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    //  {
    //   title: "Contracting Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Line manager call",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Kick-off Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Alignment Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Alignment Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Alignment Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Alignment Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Alignment Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Alignment Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Alignment Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Alignment Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Email 360º Stakeholder Survey",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },

    // {
    //   title: "1st Coaching session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Choice of Coach Email ",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },{
    //   title: "2nd Coaching session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },

    // {
    //   title: "Alignment Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },
    // {
    //   title: "Alignment Session",
    //   field: "level_structure",
    //   emptyValue: "-",
    //   hidden: true,
    // },

    {
      title: "Assignment view",
      field: "id",
      notExportable: true,
      cellStyle: {
        width: "10%",
      },
      headerStyle: {
        textAlign: "left",
      },
      render: (rowData) => (
        <div id={`div-${rowData.id}`}>
          <IconButton
            className={classes.textSecondary}
            aria-label="more"
            aria-controls={`long-menu-${rowData.id}`}
            aria-haspopup="true"
            onClick={(e) => {
              setCurrentSelection(rowData);
              handleClick(e);
            }}
          >
            <MoreVertIcon color="secondary" />
          </IconButton>
        </div>
      ),
    },
  ];

  // useEffect(() => {
  //   DataService.getDirectData(
  //     `/management_information_fields/show_mi_selected_fields`
  //   )
  //     .then((res) => {
  //       if (res?.success) {
  //         // dispatch({
  //         //   type: SET_COLUMNS,
  //         //   payload: { columns: [...filteredColumns] },
  //         // });
  //         setColumnsState((prev) => {
  //           const enabledColumns = res?.mi_fields.map((el) => el.name);
  //           const filteredColumns = [
  //             ...prev
  //               .filter((el) => el.field !== "id")
  //               .map((el) => {
  //                 if (enabledColumns.includes(el.field)) {
  //                   return { ...el, hidden: false };
  //                 } else {
  //                   return { ...el, hidden: true };
  //                 }
  //               }),
  //             prev[prev.length - 1],
  //           ];
  //           return filteredColumns;
  //         });
  //       }
  //     })
  //     .catch((err) => {});
  // }, []);

  const [columnsState, setColumnsState] = useState(InitialColumns);

  console.log(columnsState, columnsState.length, "columns");
  const handleClose = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(modules);
      setModules(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setCurrentSelection({});
  };

  const handleOption = (option) => {
    setDropDownOption(option);
    if (option === "View summary") {
      setAction("view_summary");
      history.push({
        pathname: "/assignmentsummary",
        state: { currentAssignment: currentSelection },
      });
    }
    if (option === "View details") {
      history.push({
        pathname: "/assignmentoverview",
        state: { currentAssignment: currentSelection },
      });
    } else if (option === "Send on Cal, or Repair") {
      setAction("on_repair");
    } else if (option === "View Cert") {
    } else {
      setAction(option);
    }
  };

  useEffect(() => {
    if (role === "admin" || role === "employee") {
      fetchOrganization();
      fetchService();
    }
  }, []);

  const fetchOrganization = () => {
    DataService.getDirectData(`/organisations`)
      .then((res) => {
        if (res?.success) {
          setOrganizationList(res["organisations"]);
        }
      })
      .catch((err) => {});
  };
  const fetchService = () => {
    DataService.getData({}, "fetch_service")
      .then((res) => {
        if (res?.success) {
          setServiceList(res["services"]);
        }
      })
      .catch((error) => {});
  };

  const ShowColumnsSelector = useCallback(() => {
    return (
      <ColumnsSelector
        setColumns={setColumnsState}
        InitialColumns={columnsState}
      />
    );
  }, []);

  return (
    <Box mx={2} marginLeft={3}>
      <Typography
        style={{
          padding: "15px",
          fontWeight: "800",
          position: "sticky",
          left: "0px",
        }}
        variant="h1"
        color="primary"
      >
        Assignments
      </Typography>

      <div className={classes.miTable}>
        <MaterialTable
          isLoading={organizationLoader}
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className={classes.searchCategory}>
                <SearchByCategory
                  options={dropdownOptions}
                  selectedOption={searchCategory}
                  defaultOption={"All"}
                  setSelectedOption={(event) => {
                    setSearchCategory(event);
                  }}
                  style={{ fontSize: "16px" }}
                  searchText={searchText}
                  handleSearchText={(event) => {
                    setSearchText(event);
                  }}
                />
              </div>
            </div>
          }
          options={{
            actionsColumnIndex: -1,
            pageSize: pageSize,
            columnsButton: false,
            search: false,
            total: totalCount,
            emptyRowsWhenPaging: false,
            sorting: true,
            pageSizeOptions: [100, 150, 250, 400, 500],
            headerStyle: {
              position: "sticky",
              top: "0",
            },
            maxBodyHeight: "600px",

            exportAllData: true,
            exportButton: false,
            exportFileName: "Management Information ",
            fixedColumns: {
              right: 1,
            },
          }}
          localization={{
            toolbar: {
              // nRowsSelected: "{0} Booking selected",
              // searchPlaceholder: "Search Coachee name",
              // addRemoveColumns: (
              //   <Typography
              //     variant="subtitle1"
              //     style={{ fontWeight: 700 }}
              //     className={classes.textPrimary}
              //   >
              //     Add or remove columns{" "}
              //   </Typography>
              // ),
              exportAriaLabel: "Download as CSV",
              exportTitle: <TooltipWrapper text="Download as CSV" />,
              exportName: "Download as CSV",
              showColumnsTitle: <TooltipWrapper text="Show columns" />,
              showColumnsAriaLabel: "Show columns",
            },
          }}
          columns={columnsState}
          data={assignmentData}
          totalCount={totalCount}
          page={page}
          onChangePage={(page) => {
            setPage(page);
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onSearchChange={(search) => {
            setSearchText(search);
          }}
          onChangeColumnHidden={(column, hidden) => {
            setHiddenCol(true);
          }}
          actions={[
            {
              icon: ShowColumnsSelector,
              isFreeAction: true,
            },
            {
              icon: () => {
                let params = {
                  page: page + 1 || 1,
                  count_per_page: totalCount || 20,
                };
                if (organisationId) {
                  params["organisation_id"] = organisationId;
                }

                if (searchCategory?.value) {
                  params["programme_type"] = searchCategory?.value;
                }

                if (searchText) {
                  params["coachee_name"] = searchText;
                  params["search_keyword"] = searchText;
                }
                console.log(params, "params", mainFilter);
                let url = "/assignments/list_org_assignments";
                return (
                  <ExportSelector
                    params={params}
                    columns={columnsState}
                    url={url}
                    downloadKey="assignments"
                    fileName="MI Assignments"
                  />
                );
              },
              isFreeAction: true,
            },
          ]}
        />
        <div className={classes.actionButtons}>
          <div style={{ width: "50%", position: "absolute", marginTop: "8px" }}>
            <Grid container xs={12}>
              <Grid xs={2}>
                <StatusDot variant="positive" />
                &nbsp;&nbsp;
                <Typography variant="h2" component="span">
                  On track
                </Typography>
              </Grid>
              <Grid xs={2}>
                <StatusDot variant="warning" />
                &nbsp;&nbsp;
                <Typography variant="h2" component="span">
                  On hold
                </Typography>
              </Grid>
              <Grid xs={4} lg={4} md={5}>
                <StatusDot variant="negative" />
                &nbsp;&nbsp;
                <Typography variant="h2" component="span">
                  Needs immediate attention
                </Typography>
              </Grid>
            </Grid>
          </div>
        </div>
        <Menu
          id={`long-menu`}
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleCloseMenu}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: "20ch",
            },
          }}
        >
          {currentSelection.calibration_certificate === null
            ? filteredItems.map((option) => (
                <MenuItem
                  key={option}
                  className={classes.textSecondary}
                  onClick={() => {
                    handleOption(option);
                  }}
                >
                  <Typography variant="h2">{option}</Typography>
                </MenuItem>
              ))
            : options1.map((option) => (
                <MenuItem
                  key={option}
                  className={classes.textSecondary}
                  onClick={() => {
                    handleOption(option);
                  }}
                >
                  <Typography variant="h2">{option}</Typography>
                </MenuItem>
              ))}
        </Menu>
        {currentSelection.document === null ? (
          viewAction === "view_more" && (
            <Popover
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              style={{ top: "27px", left: "2%" }}
              transformOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              open={viewAction === "view_more"}
              anchorEl={anchorPopover}
              onBackdropClick={() => setViewAction(null)}
            >
              <div>
                <Typography
                  style={{ padding: "5px 0 5px 15px" }}
                  variant="subtitle1"
                  color="secondary"
                >
                  Credentials
                </Typography>
                <List style={{ padding: "15px" }} dense>
                  <Typography variant="h2">
                    Username: {currentSelection.username} <br />
                    Password: {currentSelection.password}
                  </Typography>
                </List>
              </div>
            </Popover>
          )
        ) : (
          <Popover
            anchorOrigin={{
              vertical: "center",
              horizontal: "left",
            }}
            style={{ top: "45px", left: "2px" }}
            transformOrigin={{
              vertical: "center",
              horizontal: "left",
            }}
            open={viewAction === "view_more"}
            anchorEl={anchorPopover}
            onBackdropClick={() => setViewAction(null)}
          >
            <Typography
              style={{ padding: "20px" }}
              variant="subtitle1"
              color="secondary"
            >
              {currentSelection.alert_message}
            </Typography>{" "}
          </Popover>
        )}
      </div>
      {action === "view_summary" && (
        <ViewSummary
          action={action}
          moduleId={data.id}
          data={data}
          handleClose={handleClose}
        />
      )}

      <MIFeedbackModal
        isOpen={isFeedback}
        currentSelection={currentSelection}
        onClose={() => {
          setIsFeedback(false);
        }}
      />
    </Box>
  );
}

export default Assignment;
